import { useContext } from 'react';
import { CartContext } from '../../contexts/cart.context';
import {CheckoutItemContainer, ImageContainer, ItemDetails, BaseSpan, Quantity, Arrow, Value, RemoveButton} from './checkout-card.styles.jsx';


const CheckoutCard = ( {product} ) => {
    const { id, name, price, imageUrl, quantity } = product;
    
    const { addItemToCart, decreaseQuantity, removeItemFromCart } = useContext(CartContext);
    
    const increaseButton = () => addItemToCart(product);
    const decreaseButton = () => decreaseQuantity(product);
    const removeButton = () => removeItemFromCart(product);

    return (
        <CheckoutItemContainer key={id}>
            <ImageContainer>
                <img src={imageUrl} alt={`${name}`} />
            </ImageContainer>
            <ItemDetails>
                <BaseSpan> {name} </BaseSpan>
                <Quantity>
                    <Arrow onClick={decreaseButton}>&#10094;</Arrow>
                    <Value>{quantity}</Value>
                    <Arrow onClick={increaseButton}>&#10095;</Arrow>
                </Quantity>
                <BaseSpan>{price}</BaseSpan>
                <RemoveButton onClick={removeButton}>&#10005;</RemoveButton>
            </ItemDetails>
        </CheckoutItemContainer>
    )
};

export default CheckoutCard;